import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ProfileService } from 'src/app/core/services/profile.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-additional-library-confirmation',
  templateUrl: './additional-library-confirmation.component.html',
  styleUrls: ['./additional-library-confirmation.component.scss']
})
export class AdditionalLibraryConfirmationComponent implements OnInit {
@Input() additionalLib;
imagePath = environment.url;
  constructor(
    private activeModal: NgbActiveModal,
  ) { }

  ngOnInit() {
  }

  closeDialog() {
    this.activeModal.close();
  }
  removeConnection(){
    this.activeModal.close(true);
  }

}
